export default __webpack_public_path__ + "static/media/bg-ico-hero.cde983ac.jpg";